import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { setAccessToken } from "./api";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import "./assets/theme.css";

// Dev overlay workaround: ResizeObserver loop errors are noisy browser warnings.
if (typeof window !== "undefined") {
  const isResizeObserverNoise = (message: string) =>
    message.includes("ResizeObserver loop completed") ||
    message.includes("ResizeObserver loop limit exceeded");

  window.addEventListener(
    "error",
    (event) => {
      const message = String(
        event?.message || (event as any)?.error?.message || ""
      );
      if (isResizeObserverNoise(message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason as any;
    const message = String(reason?.message || reason || "");
    if (isResizeObserverNoise(message)) {
      event.preventDefault();
    }
  });
}

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  locale: {
    locale: "hu",
  },
  date: {
    locale: {
      hu: "hu-HU",
    },
  },
});

const app = createApp(App).use(store).use(router).use(vuetify);

async function bootstrapAuth() {
  const token = localStorage.getItem("accessToken");
  if (!token) return;

  setAccessToken(token);
  await store.dispatch("loadUserFromToken", { force: true });
}

(async () => {
  app.mount("#app");
  await router.isReady();
  await bootstrapAuth();
})();
